import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
	root: {
		paddingTop: '20px',
	},
});
